<span>{{item.text | translate}}</span>